module.exports = __webpack_public_path__ + "static/media/sharpie.d4554daa.png";